import React from 'react';
import { IonPage } from '@ionic/react';
import { BillablesCatalog, TitleBar } from '../components';
import { useHistory } from 'react-router-dom';

const BillablesCatalogPage = () => {
    const history = useHistory();
    return (
        <IonPage className="page-background-color">
            <TitleBar
                isBackMode={true}
                arrowBackClick={() => {
                    history.goBack();
                }}
            />
            <BillablesCatalog />
        </IonPage>
    );
};

export default BillablesCatalogPage;
